import styled from 'styled-components';

export const EmptyContainer = styled.div`
  background: ${({ theme }) => theme.palette.common.white};
  border-radius: 8px;
  font-size: 14px;
  text-align: center;

  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  h1 {
    margin: 0;
    color: ${({ theme }) => theme.palette.text.primary};
    font-size: 20px;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0.15px;
  }

  p {
    color: ${({ theme }) => theme.palette.text.secondary};
    margin: 0;
    font-size: 14px;
    font-weight: 400;
    line-height: normal;
    letter-spacing: 0.15px;
  }
`;
